module.exports = __webpack_public_path__ + "static/mini_calendar_example_template-933de376c9b24f858c386f129f9ba7d4.png";